import * as React from 'react';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { GridComponent } from '../../../toolkit/grid/gridcomponent';
import { ToneDto, ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { SearchListComponentProps, SearchListComponentHandler, SearchListComponentState } from './searchlistcomponent';
import { SearchListCSSStyle } from './searchlistcss';
import { SearchBoxToneOptionComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptioncomponent';
import { NoResultComponent } from '../../nametunes/noresult/noresultcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { SearchListToneViewModelImpl } from './searchlistviewmodel';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { SearchListAtistToneViewModelImpl } from './artist/searchlistartistviewmodel';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { GridPaginationListViewModel } from '../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';
import { GridPaginationComponent } from '../../../toolkit/grid/gridpagination/gridpaginationcomponent';
import './searchlist-style.css';


export class SearchListViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private popUpComponent: PopUpWrapperComponent;
    private searchComponent: SearchBoxToneOptionComponent;
    private paginationComponent: GridPaginationComponent<ToneDto>;
    private loaderWrapperComponent:LoaderWrapperComponent;
   
    constructor(private featuredCategoryListViewModel: SearchListToneViewModelImpl,
        private searchListAtistToneViewModelImpl: SearchListAtistToneViewModelImpl, context:BaseContext, handler:UIComponentHandler)
    {
        super(context,handler);
    }

    bindHandlers()
    {
        this.onSearchClick = this.onSearchClick.bind(this);
        this.clearData = this.clearData.bind(this);
        this.closePopup= this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
    }

    draw(props: SearchListComponentProps, state: SearchListComponentState, cssStyle: SearchListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("------searchKey: " + props.searchKey);

        // this.featuredCategoryListViewModel.setTitleCSSStyle(cssStyle.getTitleCSSStyle());
        // this.featuredCategoryListViewModel.setTitle("Search Results For " + props.searchKey);
        return (
            <>
            {
                    this.getWebView(props, state, cssStyle)
                }
           
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }

    getWebView(props: SearchListComponentProps, state: SearchListComponentState, cssStyle: SearchListCSSStyle):JSX.Element
    {
        return(
            <>
                <div id="search-list-wrapper2" style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getInnerWrapperCSSStyle()}>
                    <div id="search-list-inner-wrapper" style={{width:'70%',height:'60px',margin:'auto'}}>
                            <div id="search-box">
                                <SearchBoxToneOptionComponent type={props.type} ref={(item: any) => this.searchComponent = item}  context={props.context}  searchKey={props.searchKey} onSearchBoxButtonClicked={this.onSearchClick}/>
                                    
                            </div>
                            <div id="search-clear">
                                < img id="search-clear-img" onClick={this.clearData}  src={this.getContext().getResources().getImage("close.svg")}/>
                            </div>
                    </div>
                   
                     {
                         this.featuredCategoryListViewModel.getListOfDatas().length > 0 &&
                         <div id="search-result-card">
                            {
                                this.getSearchResult(props.context, this.featuredCategoryListViewModel)

                            }
                       </div>
                     }
                     {
                         this.searchListAtistToneViewModelImpl.getListOfDatas().length > 0 &&
                         <div id="search-result-card" style={{}}>
                            {
                                this.getArtistSearchResult(props.context, this.searchListAtistToneViewModelImpl)

                            }
                       </div>
                     }
                     {
                         state.isEmpty &&
                       <div id="search-noresult-card" style={{width:'100%',height:'160px',marginBottom:'50px'}}/>
                     }   
                       {state.isDataNotLoaded &&
                       <div id="search-noresult-card" style={{width:'100%',height:'100%',marginBottom:'50px'}}>
                              <NoResultComponent   context={this.getContext()}/>
                       </div>    
                     }

                    {/* {!state.isDataNotLoaded &&
                       <div style={{width:'100%',height:'160px',marginBottom:'50px'}}/>
                     } */}
                      
                 </div>
                  
                   
            </div>
            </>
        );
    }

    // getMobileView(props: SearchListComponentProps, state: SearchListComponentState, cssStyle: SearchListCSSStyle):JSX.Element
    // {
    //     return(
    //         <>
    //              <div id="search-list-col-wrapper2" style={cssStyle.getWrapperCSSStyle()}>
    //             <div style={cssStyle.getInnerWrapperCSSStyle()}>
    //                 <div id="search-list-col-inner-wrapper" style={{width:'70%',height:'60px',margin:'auto'}}>
    //                         <div style={{width:'90%',height:'60px',alignItems:'center'}}>
    //                             <SearchBoxToneOptionComponent type={props.type} ref={(item: any) => this.searchComponent = item}  context={props.context}  searchKey={props.searchKey} onSearchBoxButtonClicked={this.onSearchClick}/>
                                    
    //                         </div>
    //                         <div style={{width:'5%',height:'100%',alignItems:'center',paddingTop:'5px',paddingLeft:'15px',cursor:'pointer'}}>
    //                             < img id="search-col-clear" onClick={this.clearData} style={{width:'20px',height:'20px'}} src={this.getContext().getResources().getImage("close.svg")}/>
    //                         </div>
    //                 </div>
                   
    //                  {
    //                      this.featuredCategoryListViewModel.getListOfDatas().length > 0 &&
    //                      <div style={{ paddingLeft: "9.9%", paddingRight: "5.3%",  marginBottom:'200px'}}>
    //                         {
    //                             this.getSearchResult(props.context, this.featuredCategoryListViewModel)

    //                         }
    //                    </div>
    //                  }
    //                  {
    //                      this.searchListAtistToneViewModelImpl.getListOfDatas().length > 0 &&
    //                      <div style={{ paddingLeft: "9.9%", paddingRight: "5.3%", marginBottom:'200px'}}>
    //                         {
    //                             this.getSearchResult(props.context, this.searchListAtistToneViewModelImpl)

    //                         }
    //                    </div>
    //                  }
    //                  {
    //                      state.isEmpty &&
    //                    <div style={{width:'100%',height:'160px',marginBottom:'50px'}}/>
    //                  }   
    //                    {state.isDataNotLoaded &&
    //                    <div style={{width:'100%',height:'100%',marginBottom:'50px'}}>
    //                           <NoResultComponent   context={this.getContext()}/>
    //                    </div>    
    //                  }

    //                 {/* {!state.isDataNotLoaded &&
    //                    <div style={{width:'100%',height:'160px',marginBottom:'50px'}}/>
    //                  } */}
                      
    //              </div>
                  
                   
    //         </div>
    //         </>
    //     );
    // }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
     closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    showPopup(msg:string,type:AlertType):void
    {
        this.closePopup();
         if(type === AlertType.WARN)
         {
             
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={()=>''} context={this.getUIProps().context}/>);

         }
        
         else 
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

         }
    }
    getSearchResult(context:BaseContext, listviewmodel: GridPaginationListViewModel<ToneDto>):JSX.Element
    {
        // (this.listViewModel as ListViewModelImpl<ToneDto>).setTitleCSSStyle(cssStyle.getTitleCSSStyle());
        // this.featuredCategoryListViewModel.setListDatas(this.getListOfTones());
        return ( 
            <>
            {/* web:padding:0 */}
           {/* fontsize:15px pading top:20px , marginbottom:20px, padding left:20px */}
           <h2 id="search-result-for-label" style={(this.getUICSSStyle() as SearchListCSSStyle).getTitleCSSStyle()}>{context.getResources().getString(Strings.search_results_for) + " " + (this.getUIProps() as SearchListComponentProps).searchKey}</h2>
                <GridComponent listViewModel={listviewmodel} context={context}/>
                <div id="search-list-pagination" style={(this.getUICSSStyle() as SearchListCSSStyle).getPaginationCSSStyle()}>
                    <GridPaginationComponent ref={(item: any) => this.paginationComponent = item} onPageSelected={this.onLoadMore} listViewModel={listviewmodel} context={context}/>
                </div>
            </>
            );

    }

    updatePaginationCount()
    {
        this.paginationComponent !== undefined && this.paginationComponent.updatePaginationCount();
    }
    onLoadMore(startIndex: number, offset: number)
    {
        (this.getUIComponentHandler() as SearchListComponentHandler).onLoadMore(startIndex, offset);
    }

    clearData():void
    {
        this.searchComponent.clearData();

        // (this.getUIComponentHandler() as SearchListComponentHandler).onDataNotLoaded(false);
    }
    onSearchClick(searchKey:string, type: string):void
    {
        console.log("-----searchKey " + searchKey + ", type: " + type);

        if(this.searchComponent.validate())
        {
            searchKey = searchKey.trim();
            (this.getUIComponentHandler() as SearchListComponentHandler).onDataNotLoaded(false);
            (this.getUIComponentHandler() as SearchListComponentHandler).onSearchClicked(searchKey, type);
        }
    }
    getListOfTones()
    {  let tone1 = new ToneDtoImpl();
        tone1.setId("1");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk jhgfdsdfghjk jhgfdfghjk ");
        tone1.setImgPath("http://placehold.it/120x120&text=image1");

        let tone2 = new ToneDtoImpl();
        tone2.setId("2");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk 87654 87654");
        tone2.setImgPath("http://placehold.it/120x120&text=image2");

        let tone3 = new ToneDtoImpl();
        tone3.setId("3");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk9 87659876545678");
        tone3.setImgPath("http://placehold.it/120x120&text=image3");

        let tone4 = new ToneDtoImpl();
        tone4.setId("4");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image4");

    //     // let tone5 = new ToneDtoImpl();
    //     // tone5.setId("5");
    //     // tone5.setToneName("1234rsva");
    //     // tone5.setArtistName("987ytrfgbnmk");
    //     // tone5.setImgPath("http://placehold.it/120x120&text=image5");

    //     // let tone6 = new ToneDtoImpl();
    //     // tone6.setId("6");
    //     // tone6.setToneName("1234rsva");
    //     // tone6.setArtistName("987ytrfgbnmk");
    //     // tone6.setImgPath("http://placehold.it/120x120&text=image6");

    //     // let tone7 = new ToneDtoImpl();
    //     // tone7.setId("7");
    //     // tone7.setToneName("1234rsva");
    //     // tone7.setArtistName("987ytrfgbnmk");
    //     // tone7.setImgPath("http://placehold.it/120x120&text=image7");

    //     // let tone8 = new ToneDtoImpl();
    //     // tone8.setId("8");
    //     // tone8.setToneName("1234rsva");
    //     // tone8.setArtistName("987ytrfgbnmk");
    //     // tone8.setImgPath("http://placehold.it/120x120&text=image8");
        return [tone1, tone2, tone3, tone4];
    }

    getArtistSearchResult(context:BaseContext, listviewmodel: GridPaginationListViewModel<ToneDto>):JSX.Element
    {
        // (this.listViewModel as ListViewModelImpl<ToneDto>).setTitleCSSStyle(cssStyle.getTitleCSSStyle());
        // this.featuredCategoryListViewModel.setListDatas(this.getListOfTones());
        return ( 
            <>
            {/* {/ web:padding:0 /}
           {/ fontsize:15px pading top:20px , marginbottom:20px, padding left:20px /} */}
           <h2 id="search-result-for-label" style={(this.getUICSSStyle() as SearchListCSSStyle).getTitleCSSStyle()}>{context.getResources().getString(Strings.search_results_for) + (this.getUIProps() as SearchListComponentProps).searchKey}</h2>
                <div id="artist-search-result-for-label">
                <GridComponent listViewModel={listviewmodel} context={context}/>
                </div>
                <div id="search-list-pagination" style={(this.getUICSSStyle() as SearchListCSSStyle).getPaginationCSSStyle()}>
                    <GridPaginationComponent ref={(item: any) => this.paginationComponent = item} onPageSelected={this.onLoadMore} listViewModel={listviewmodel} context={context}/>
                </div>
            </>
            );

    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/searchlistview.tsx